import styled from '@emotion/styled';
import { Play } from 'styles/icons';

const PlayIcon = styled(Play)({
  height: '1rem',
  marginRight: '1rem',
});

export default PlayIcon;
